import { render, staticRenderFns } from "./a-spacer.vue?vue&type=template&id=707e0b86&scoped=true"
import script from "./a-spacer.vue?vue&type=script&lang=js"
export * from "./a-spacer.vue?vue&type=script&lang=js"
import style0 from "./a-spacer.vue?vue&type=style&index=0&id=707e0b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707e0b86",
  null
  
)

export default component.exports